import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import { useDisclosure } from '@hooks/useDisclosure';
import Remark from '@Components/Remark';

import {
  BusinessValueChainFormValues,
  IImpactsOnStakeholdersFormValues,
} from '../ImpactsOnStakeholdersFormProvider/types';
import { useImpactsOnStakeholdersForm } from '../ImpactsOnStakeholdersFormProvider';

export const BUSINESS_REMARK_ID = 'business-remark';

const BusinessValueChainRemark = () => {
  const { control, getValues } = useImpactsOnStakeholdersForm();
  const { remark } =
    getValues(`businessValueChain`) ?? ({} as IImpactsOnStakeholdersFormValues);

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!remark);

  const businessRemarkEl = document.getElementById(BUSINESS_REMARK_ID);

  const { completedSection } =
    useWatch({
      name: 'businessValueChain',
      control,
    }) ?? ({} as BusinessValueChainFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isIntroductionOpen &&
        businessRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="ห่วงโซ่คุณค่าธุรกิจ"
              setOpen={open}
              fieldPath="businessValueChain.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          businessRemarkEl
        )}
    </>
  );
};

export default BusinessValueChainRemark;
